var map = {
	"./en/common.json": [
		4250,
		250
	],
	"./en/home.json": [
		3572,
		572
	],
	"./en/messages.json": [
		7967,
		967
	],
	"./en/privacy.json": [
		6925,
		925
	],
	"./en/terms.json": [
		6934,
		934
	],
	"./fr/common.json": [
		3635,
		635
	],
	"./fr/home.json": [
		7569,
		569
	],
	"./fr/messages.json": [
		3994,
		994
	],
	"./fr/privacy.json": [
		4878,
		878
	],
	"./fr/terms.json": [
		8341,
		341
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5056;
module.exports = webpackAsyncContext;